export function getServerUrl() {
  return process.env.VUE_APP_BASE_API;
}
